import client from './client';

/**
 * 이슈
 */
export const issueReport = (param) =>
  client.get(`/api/report/issue`, { params: param });

/**
 * 광고주별 통계
 */
export const advertiserStatistics = (param) =>
  client.get(`/api/ch_report/adver`, param);


/**
 * 광고주별 통계 그래프
 */
export const advertiserMonthData = (param) =>
  client.get(`/api/report/adver/graph/monthData`, { params: param });

/**
 * 광고주별 예산 통계 그래프
 */
export const budgetGraphData = (param) =>
  client.get(`/api/report/adver/budget/graph`, { params: param });

/**
 * 광고주별 통계 등급표
 */
export const getAdverRnkBoard = (params) =>
  client.get(`/api/report/adver/adverRnkBoard`, params);

/**
 * 광고주별 상위 100개 광고주 등급표
 */
export const getAdverTopRnkBoard = (params) =>
  client.get(`/api/ch_report/adver/adverTopRnkBoard`, params);

/**
 * 광고주별 예산 통계
 */
export const budgetStatistics = (param) =>
  client.get(`/api/report/adver/budget`, param);

/**
 * 광고주 등락보고 그래프
 */
export const FluctuationGraphData = (param) =>
  client.get(`/api/report/adver/fluctuation/graph`, { params: param });

/**
 * 광고주별 비교통계
 */
export const amtCompareStatistics = (param) =>
  client.get(`/api/report/adver/compare`, param);

/**
 * 광고주별 구간비교통계
 */
export const SectionCompareStatistics = (param) =>
  client.get(`/api/report/adver/sectionCompare`, param);

/**
 * 매체 등락보고 그래프
 */
export const FluctuationMediaGraphData = (param) =>
  client.get(`/api/report/media/fluctuation/graph`, { params: param });

/**
 * 광고주 등락보고 그래프
 */
export const FluctuationStatisticsData = (param) =>
  client.get(`/api/report/adver/fluctuation`, param);

/**
 * 광고주별 미소진 통계
 */
export const unpaidStatistics = (param) =>
  client.get(`/api/report/adver/unpaid`, param);

/**
 * 휴면 광고주 통계
 */
export const dormancyStatistics = (param) =>
  client.get(`/api/report/adver/dormancy`, param);

/**
 * 프리퀀시별 통계
 */
export const freqGraph = (param) =>
  client.get(`/api​/report/freq/graph`, param);

/**
 * T-time 통계 그래프 (변수별)
 */
export const freqTtimeGraph = (param) =>
  client.get(`/api/report/freq/ttimegraph`, { params: param });

/**
 * T-time 통계 그래프 (전략별)
 */
export const FreqStatisticsTtimeGraphData = (param) =>
  client.get(`/api/report/freq/ttimegraphStt`, { params: param });

/**
 * 광고주별상세통계
 */
export const adverDetailStatistics = (param) =>
  client.get(`/api/ch_report/adver/targeting`, param);
